import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=3a12f206&scoped=true"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"
import style0 from "./orders.vue?vue&type=style&index=0&id=3a12f206&prod&lang=stylus&scoped=true"
import style1 from "./orders.vue?vue&type=style&index=1&id=3a12f206&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a12f206",
  null
  
)

export default component.exports